var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencilSquare = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.648,
    height: 14.5,
    viewBox: "0 0 14.648 14.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-square",
    transform: "translate(-1 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M15.5,1.94a.5.5,0,0,1,0,.706L14.459,3.69l-2-2L13.5.646a.5.5,0,0,1,.707,0L15.5,1.939ZM13.752,4.4l-2-2L4.939,9.21a.5.5,0,0,0-.121.2l-.8,2.414a.25.25,0,0,0,.316.316l2.414-.805a.5.5,0,0,0,.2-.12L13.752,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M1,13.5A1.5,1.5,0,0,0,2.5,15h11A1.5,1.5,0,0,0,15,13.5v-6a.5.5,0,0,0-1,0v6a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2H9A.5.5,0,0,0,9,1H2.5A1.5,1.5,0,0,0,1,2.5Z",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencilSquare);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC42NDgiIGhlaWdodD0iMTQuNSIgdmlld0JveD0iMCAwIDE0LjY0OCAxNC41Ij4KICA8ZyBpZD0icGVuY2lsLXNxdWFyZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTAuNSkiPgogICAgPHBhdGggaWQ9IlBhdGhfMTA5OCIgZGF0YS1uYW1lPSJQYXRoIDEwOTgiIGQ9Ik0xNS41LDEuOTRhLjUuNSwwLDAsMSwwLC43MDZMMTQuNDU5LDMuNjlsLTItMkwxMy41LjY0NmEuNS41LDAsMCwxLC43MDcsMEwxNS41LDEuOTM5Wk0xMy43NTIsNC40bC0yLTJMNC45MzksOS4yMWEuNS41LDAsMCwwLS4xMjEuMmwtLjgsMi40MTRhLjI1LjI1LDAsMCwwLC4zMTYuMzE2bDIuNDE0LS44MDVhLjUuNSwwLDAsMCwuMi0uMTJMMTMuNzUyLDQuNFoiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEwOTkiIGRhdGEtbmFtZT0iUGF0aCAxMDk5IiBkPSJNMSwxMy41QTEuNSwxLjUsMCwwLDAsMi41LDE1aDExQTEuNSwxLjUsMCwwLDAsMTUsMTMuNXYtNmEuNS41LDAsMCwwLTEsMHY2YS41LjUsMCwwLDEtLjUuNUgyLjVhLjUuNSwwLDAsMS0uNS0uNVYyLjVBLjUuNSwwLDAsMSwyLjUsMkg5QS41LjUsMCwwLDAsOSwxSDIuNUExLjUsMS41LDAsMCwwLDEsMi41WiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgPC9nPgo8L3N2Zz4K";